import {
  breakpoints,
  Heading,
  PageBlock,
  Stack,
  Text,
  textColors,
  textVariants,
  vars,
} from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css, cx } from '@eti/styles';
import { backgroundImageTypes, useBackgroundImage } from '../../../utils/backgroundImage';
import { getDestinationBackgroundImage } from '../../../utils/destinationBackgroundImage';

const blockStyles = css`
  position: relative;

  @media (min-width: ${breakpoints._1024}) {
    padding-block: 100px;
  }

  &::before {
    @media (max-width: 47.9375rem) {
      background-image: linear-gradient(transparent, rgb(14 86 130 / 85%));
      content: '';
      display: grid;
      height: 100%;
      place-content: center;
      pointer-events: none;
      position: absolute;
      width: 100%;
    }
  }
`;

const cardStyles = css`
  border-radius: ${vars.card.borderRadius};
  color: #fff;
  margin: 0 auto;
  max-width: 50rem;
  padding-block: 1rem;
  position: relative;

  @media (min-width: ${breakpoints._768}) {
    background-color: rgb(14 86 130 / 80%);
    padding: 1.5rem;
  }
`;

const Header = ({ destinationCityCode }: { destinationCityCode: string }) => {
  const { t } = useTranslation();
  const { cssClass } = useBackgroundImage(
    getDestinationBackgroundImage(destinationCityCode),
    backgroundImageTypes.LOCATION,
  );

  return (
    <PageBlock className={cx(cssClass, blockStyles)} withPaddingY>
      <Stack className={cardStyles} spacing={8}>
        <Heading id="postbooking-heading" level={1}>
          {t('PostBooking.ExtraProducts.Header.Title')}
        </Heading>
        <Text color={textColors.WHITE} variant={textVariants._16}>
          {t('PostBooking.ExtraProducts.Header.Label')}
        </Text>
      </Stack>
    </PageBlock>
  );
};

export default Header;
